import * as React from "react";
import styled from "styled-components";
import { mobile } from "../../_themes/constants/";
import { getColor } from "../../_themes/helpers";
import { Icon } from "../../IconSVG";

export const ArrowIcon = props => <Icon type="keyboardarrow" {...props} />;

export const PreviousIcon = styled.div`
  display: flex;
  flex: 1;
  svg {
    display: inline-block;
    margin: auto;
    transform: rotate(90deg);
    visibility: ${({ onClick }) => (onClick ? "visible" : "hidden")};
    color: ${getColor(
      "settingsWindowNavigationButton",
      "settingsWindow.navigationButton"
    )};
    width: ${mobile.landscape.sidePanel.icon.width};
    height: ${mobile.landscape.sidePanel.icon.height};
  }
`;

export const PreviousButton = props => (
  <PreviousIcon {...props}>
    <ArrowIcon {...props} />
  </PreviousIcon>
);
